import { SessionStorage } from '@bhtp-client-api/base';
import { Constants } from '@bhtp-client-web/component';
import { Injectable, Injector, Inject } from '@angular/core';
import { AmbassadorInformation, ApiAgentInformation } from '../models';
import { AgentCodeTypeaheadService } from './agent-code-typeahead.service';

@Injectable()
export class AmbassadorInformationSessionStorage {
    private readonly sessionKey: string = 'ambassadorInformation';
    private readonly agentCodeKey: string = 'agentCode';
    private readonly agencyCodeKey: string = 'agencyCode';
    private readonly defaultAgency: string = 'BHTP';

    constructor(private sessionStorage: SessionStorage, private agentCodeService: AgentCodeTypeaheadService) {
    }

    public setSession(data: AmbassadorInformation): void {
        this.sessionStorage.storeValueOfType<AmbassadorInformation>(this.sessionKey, data);
    }

    public getSession(): AmbassadorInformation {
        return this.sessionStorage.getValueOfType<AmbassadorInformation>(this.sessionKey);
    }

    public clearSessionData(): void {
        this.sessionStorage.removeValue(this.sessionKey);
    }

    public getAgentCode(): string {
        return this.getValue(this.agentCodeKey);
    }

    public getAgencyCode(): string {
        return this.getValue(this.agencyCodeKey);
    }

    public setAgentCode(agentCode: string): void {
        this.setValue(this.agentCodeKey, agentCode);

        if (agentCode) {
            this.agentCodeService.search(agentCode).subscribe(
                (agentInformation: ApiAgentInformation[]) => {
                    if (agentInformation && agentInformation.length > 0) {
                        this.setValue(this.agencyCodeKey, agentInformation[0].agencyCode);
                    }
                    else {
                        this.setValue(this.agencyCodeKey, this.defaultAgency);
                    }
                },
                (error: any) => {
                    this.setValue(this.agencyCodeKey, this.defaultAgency);
                }
            );
        }
        else {
            this.setValue(this.agencyCodeKey, '');
        }
    }

    public convertLocationDataIntoAmbassadorInformation(params: any): AmbassadorInformation {
        let information: AmbassadorInformation = this.getSession() ? this.getSession() : new AmbassadorInformation();
        let agentCodeChanged: boolean = (params[this.agentCodeKey] != null);

        let keys: string[] = Object.keys(information);

        for (let key of keys) {
            let value: any = params[key];
            if (value) {
                information[key] = value;
            }
        }

        this.setSession(information);

        if (agentCodeChanged) {
            this.setAgentCode(information.agentCode);
        }

        return information;
    }

    private getValue(valueKey): string {
        let information: AmbassadorInformation = this.getSession() ? this.getSession() : new AmbassadorInformation();
        return information[valueKey];
    }

    private setValue(valueKey: string, value: string): void {
        let information: AmbassadorInformation = this.getSession() ? this.getSession() : new AmbassadorInformation();
        information[valueKey] = value;
        this.setSession(information);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/ambassador-session.service.ts